import { createContext } from 'react';

export const ProjectsContext = createContext();
export const AuthContext = createContext();
